/**
 * Слова тарифа - ЕДИНСТВЕННОЕ место, где они написаны (единица 21, N-05,
 * N-11). Отдельно от `ProStatus.tsx`, без React: их читают и сценарии
 * (`e2e/class-plan.spec.ts`). Правило `UI-13` (`pnpm ui:check`) не пускает
 * эти слова ни в один другой файл.
 */
export const PLAN_NAME = { free: 'Бесплатный', pro: 'Pro' } as const;

/** Слово о том, можно ли сейчас оформить Pro. */
export const PRO_STATUS = {
  selling: 'можно оформить',
  waiting: 'оплата подключается',
} as const;
